import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { IndicadorEnum } from 'src/app/global/enums/indicador.enum';
import { DocumentConfig } from 'src/app/global/interfaces/document-config';
import { EstadoDocumento } from 'src/app/global/interfaces/estado-documento';
import { GeneralResponseGeneric } from 'src/app/global/interfaces/general-response-generic';

export abstract class DocumentVMService {

  documentConfig: DocumentConfig;

  abstract createForm(): FormGroup;

  abstract documentsConfig(): DocumentConfig;

  abstract saveDocuments(form: FormGroup, validForm: boolean, documentConfig: DocumentConfig): Promise<GeneralResponseGeneric<unknown, IndicadorEnum>>;
  abstract getDocumentoRequeridos(form: FormGroup);

  abstract startDocumentStatusRequester(): Observable<EstadoDocumento[]>;
  abstract deleteDocuments(): Promise<any>;
  abstract stopDocumentStatusRequester(): void;

  abstract updateDocumentStatus(documentStatusList: EstadoDocumento[], documentsConfig: DocumentConfig, form: FormGroup): void;
  abstract isDocumentLoaded(documentStatus: EstadoDocumento): boolean;
  abstract getDocumentStatus();
}
